import App from './App.svelte';

const target = document.querySelector('body');

if (!target) {
  throw Error('target is not exists!');
}

new App({ target: target });
